// extracted by mini-css-extract-plugin
module.exports = {"SolarPanelsModal":"SolarPanels_SolarPanelsModal__JsLoB"};